/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
// import core & vendor packages 
import React, { useState } from 'react';
import { Row, Col, Button, Form, FormControl } from 'react-bootstrap';

// import components 
import Table from 'components/ReactTable';
import LeaveCreditsModal from './components/Modal';

// import assets
import './index.scss';
import { ReactComponent as EyeSVG } from 'assets/svg/eye.svg';
import { ReactComponent as EditSVG } from 'assets/svg/pencil green.svg';

// main component
const state = [
  {
    employee_number: '001',
    employee_name: 'Juan Dela Cruz',
    positions: 'Nurse',
    department: 'Nursing Dept.',
    company_email_address: 'jdelacruz@mcmc.com',
    contact_number: '0913268578',
    advances_data: [
      {
        type: '00001',
        tenure: '00001',
        status: 'Active',
        interest_rate: '00001',
        principal_account: '00001',
        loan_account_number: '00001',
        loan_created_date: '00001',
        loans_list: [
          {
            year: '2022',
            total: '00001',
            balance: '00001',
            status: 'Active',
            interest: '00001',
            principal: '00001',
          },
        ],
      },
      {
        type: '00001',
        tenure: '00001',
        status: 'Inactive',
        interest_rate: '00001',
        principal_account: '00001',
        loan_account_number: '00001',
        loan_created_date: '00001',
        loans_list: [
          {
            year: '2022',
            principal: '2022',
            interest: '2022',
            total: '2022',
            balance: '2022',
            status: '2022',
          },
        ],
      },
      {
        type: '00001',
        tenure: '00001',
        status: 'Paid',
        interest_rate: '00001',
        principal_account: '00001',
        loan_account_number: '00001',
        loan_created_date: '00001',
        loans_list: [
          {
            year: '2022',
            principal: '2022',
            interest: '2022',
            total: '2022',
            balance: '2022',
            status: '2022',
          },
        ],
      },
      {
        type: '00001',
        tenure: '00001',
        status: 'Ongoing',
        interest_rate: '00001',
        principal_account: '00001',
        loan_account_number: '00001',
        loan_created_date: '00001',
        loans_list: [
          {
            year: '2022',
            principal: '2022',
            interest: '2022',
            total: '2022',
            balance: '2022',
            status: '2022',
          },
        ],
      },
    ],
  },
];

const index = ({ setShowScreen, setRequestData }) => {
const [openModal, setOpenModal] = useState();

  const tableColumns = React.useMemo(
    () => [
      { Header: 'Employee Number', accessor: 'employee_number' },
      { Header: 'Employee Name', accessor: 'employee_name' },
      { Header: 'Positions', accessor: 'positions' },
      { Header: 'Department', accessor: 'department' },
      { Header: 'Company Email Address', accessor: 'company_email_address' },
      { Header: 'Contact Number', accessor: 'contact_number' },
    ],
    [],
  );

  const tableData = React.useMemo(
    () =>
      state?.map((dd) => ({
        employee_number: dd?.employee_number,
        employee_name: dd?.employee_name,
        positions: dd?.positions,
        department: dd?.department,
        company_email_address: dd?.company_email_address,
        contact_number: dd?.contact_number,
        data: dd,
      })),
    [state],
  );

  return (
    <div className='advances-table'>
      <div className='main-table'>
        <Table
          data={tableData}
          columns={tableColumns}
          pagination={['BOTTOM']}
          customAction={(id, data) => {
            return (
              <div className='advance-actions'>
                <EyeSVG
                  onClick={() => {
                    setShowScreen(2);
                    setRequestData(data);
                  }}
                />
                <EditSVG />
              </div>
            );
          }}
        />
      </div>

      <LeaveCreditsModal openModal={openModal} setOpenModal={setOpenModal} />
    </div>
  );
};

export default index;
